import { HTMLAttributes, useRef } from 'react'

import Spinner from '@/components/base/Spinner'

import { cn } from '@/lib/utils'

export type ScrollIconProps = HTMLAttributes<HTMLSpanElement>

const ScrollIcon = ({ className, children, ...props }: ScrollIconProps) => {
  const root = useRef<HTMLSpanElement>(null)

  return (
    <span
      ref={root}
      className={cn('items-center space-x-spacing-xs lg:flex', className)}
      {...props}
    >
      <Spinner variant="small" className="shrink-0" />
      {children}
    </span>
  )
}

export default ScrollIcon
